import React from 'react';
import { pushDataLayerEvent } from '../utils/metricManagementUtil';
import { siteUrl } from '../utils/siteUrl';
import GlobalErrorModal from '../components/molecules/global-error-modal/global-error-modal';

let lastPageView = null;

const pageViewDataLayer = ({ location }) => {
  if (lastPageView === location.pathname) {
    return;
  }
  lastPageView = location.pathname;

  const dataBrowser = {
    event: 'pageView',
    location: location.href,
    page: location.pathname.replace(/^\//, ''),
    title: document.title || undefined,
    referrer: siteUrl,
  };
  pushDataLayerEvent(dataBrowser);
};

export const createOnPreRouteUpdate =
  () =>
  ({ location }) => {
    pageViewDataLayer({ location });
  };

const RootWrapper = ({ children }) => (
  <>
    {children}
    <GlobalErrorModal />
  </>
);

export const wrapRootElement = ({ element }) => (
  <RootWrapper>{element}</RootWrapper>
);
